import * as base from './base.jsx';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

class PopoverComponent extends base.BaseComponent {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      page: this.props.page || 0,
      key: this.props.key || Math.random().toString(36).substring(7)
    });
  }

  escPressed() {
    this.setState({
      page: 0
    });
    this.props.onEsc();
  }

  getClass() {
    if (this.props.showing) {
      return "popover-full-page-container"
    } else {
      return "popover-full-page-container"
    }
  }

  handleKeyDown(event) {
    if (event.keyCode === 27) {
      this.escPressed();
    }
  }

  componentWillMount(){
    window.addEventListener("keydown", this.handleKeyDown.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown.bind(this));
  }

  getContent() {
    return
  }

  getHeader() {
    return <div className="popover-header">
      <i className={this.props.headerIcon}></i>
      <div className="title">
        {this.props.title}
      </div>
      <div className="subtitle">
        {this.props.subtitle}
      </div>
    </div>
  }

  getPopoverOption(title, detail, onClick) {
    return <div
      className="popover-option"
      onClick={onClick}
    >
      <i className="icon-arrow-68"></i>
      <div className="details">
        <div className="title">
          {title}
        </div>
        <div className="detail">
          {detail}
        </div>
      </div>
    </div>
  }

  getBackButtonTitle() {
    return null;
  }

  onBack() {
    this.setState(currentState => {
      currentState.page = currentState.page - 1;
      return currentState;
    })
  }

  getBackButton() {
    var backTitle = this.getBackButtonTitle();
    if (backTitle) {
      return <div
          key={backTitle}
          className="back-button"
          onClick={this.onBack.bind(this)}
        >
          <i className="icon-arrow-67"></i>
          <div className="details">
            back
            <div className="previous-page">
              {backTitle}
            </div>
          </div>
        </div>
    } else {
      return
    }
  }

  render() {
    var insides;
    if (this.props.showing) {
      insides = <div className={this.getClass()} key={this.state.key}>
        <div className="esc-button" onClick={this.escPressed.bind(this)}>
          <i className="icon-cross"></i>
          esc
        </div>
        <CSSTransition classNames="fade" timeout={200}>
          { this.getBackButton() }
        </CSSTransition>
        { this.getHeader() }
        <div className="outside-content-container">
          <div className="content-column">
            { this.getContent() }
          </div>
        </div>
      </div>
    }

    return <CSSTransitionGroup transitionName="fade"
      transitionEnterTimeout={200} transitionLeaveTimeout={200}>
      {insides}
    </CSSTransitionGroup>
  }
}

module.exports = {
  PopoverComponent: PopoverComponent
}
